import ufeApi from 'services/api/ufeApi';
import RCPSCookies from 'utils/RCPSCookies';

const ATG_URL = '/api/secure/validatePasswordToken';
const AUTH_URL = '/api/auth/v1/validatePasswordToken';
const SDN_URL = '/gway/v1/dotcom/auth/v1/validatePasswordToken';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Validate+Password+Token+API

function validatePasswordToken(securityToken, options = {}) {
    const normalizedOptions = typeof options === 'boolean' ? { isStoreBIMemberEmailVerification: options } : options;
    const {
        isStoreBIMemberEmailVerification = false,
        pk = false
    } = normalizedOptions;
    const { isAuthServiceResetPassEnabled } = Sephora.configurationSettings;

    let URL = ATG_URL;
    let headers = {};
    const payload = { securityToken };

    if (pk) {
        payload.pk = true;
    }

    /*
    Since only Auth service can validate tokens for the email verification flow
    we are redirecting request to Auth service when isStoreBIMemberEmailVerification is true,
    no matter the status of the killswitch.
    */
    if (isAuthServiceResetPassEnabled || isStoreBIMemberEmailVerification) {
        URL = AUTH_URL;
        headers = {
            'Content-type': 'application/json',
            'x-requested-source': 'web'
        };
        payload.isStoreBIMemberEmailVerification = isStoreBIMemberEmailVerification;
    }

    if (RCPSCookies.isRCPSAuthEnabled()) {
        URL = SDN_URL;
    }

    return ufeApi
        .makeRequest(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers
        })
        .then(data => (data.errorCode || data.errors ? Promise.reject(data) : data));
}

export default validatePasswordToken;
